import { createContext, type ReactNode, use } from 'react';
import type { Me } from './api';

const DeveloperContext = createContext<Me | null>(null);

export function DeveloperProvider({ me, children }: { me: Me; children: ReactNode }) {
  return <DeveloperContext value={me}>{children}</DeveloperContext>;
}

/** The signed-in developer; only inside `<AccessGate>`. */
export function useDeveloper(): Me {
  const me = use(DeveloperContext);
  if (!me) throw new Error('useDeveloper must be used inside <AccessGate>');
  return me;
}
